import type {LabelListElement} from '../result-page/result-cards/subcomponents/uiaas-search-label-list';
import type {
  DeveloperPortalDocumentUiModel
} from '../../models/ui/documents/exchange/developer-portal-document-ui.model';

export abstract class ExstLabelsService {

  getLabels(doc:DeveloperPortalDocumentUiModel):LabelListElement[] {
      return [];
  }
}
